function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useContext, useState } from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { mdiArrowLeft, mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import { IconButton, Input, Select, LocaleContext, renderStyledColor } from '@tecsinapse/ui-kit';
import { Grid } from '@material-ui/core';

var filterStyles = function filterStyles(mobile) {
  return makeStyles(function (theme) {
    return {
      group: {
        padding: mobile ? theme.spacing(1) : '20px'
      },
      filterContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center'
      },
      filter: {
        padding: '2px'
      },
      gridItemMarginTop: {
        padding: mobile ? theme.spacing(2 / 3) : 0
      },
      fullWidth: {
        width: '100%'
      }
    };
  });
};

var advancedFilterStyles = function advancedFilterStyles(mobile) {
  return makeStyles(function (_ref) {
    var spacing = _ref.spacing;
    return {
      title: {
        height: mobile ? '20px' : '50px',
        padding: mobile ? '20px 0px 20px 0px' : '20px 20px 20px 20px',
        display: 'flex',
        alignItems: 'center',
        borderBottom: '1px #ccc solid'
      },
      panelButton: {
        height: '60px',
        borderTop: '1px #ccc solid',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      },
      panelButtonMobile: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column'
      },
      button: {
        width: '75%',
        marginTop: spacing(1)
      }
    };
  });
};

var onChangeFilter = function onChangeFilter(setAdvancedFilters, name, value) {
  setAdvancedFilters(function (prevAdvancedFilters) {
    var newAdvancedFilters = _objectSpread({}, prevAdvancedFilters);

    newAdvancedFilters[name] = value;
    return newAdvancedFilters;
  });
};

var mapFilterOptionToInput = function mapFilterOptionToInput(_ref2, setAdvancedFilters, advancedFilters) {
  var type = _ref2.type,
      name = _ref2.name,
      label = _ref2.label,
      options = _ref2.options;

  if (type === 'input' || type === 'date' || type === 'time') {
    return /*#__PURE__*/React.createElement(Input, {
      key: name,
      name: name,
      value: advancedFilters[name],
      label: label,
      mask: type === 'date' || type === 'time' ? type : null,
      onChange: function onChange(event) {
        return onChangeFilter(setAdvancedFilters, name, event.target.value);
      },
      fullWidth: true
    });
  }

  if (type === 'select' || type === 'multi-select') {
    return /*#__PURE__*/React.createElement(Select, {
      key: name,
      options: options,
      value: advancedFilters[name],
      label: label,
      isMulti: type === 'multi-select',
      onChange: function onChange(value) {
        return onChangeFilter(setAdvancedFilters, name, value);
      },
      portal: true,
      fullWidth: true
    });
  }

  if (type === 'checkbox') {
    var margin3 = {
      marginTop: 3
    };
    var padding5 = {
      paddingRight: 5
    };
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      style: margin3,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        style: padding5,
        key: name,
        onChange: function onChange(event) {
          return onChangeFilter(setAdvancedFilters, name, event.target.checked);
        },
        checked: advancedFilters[name]
      }),
      label: label
    });
  }

  return null;
};

var Filters = function Filters(_ref3) {
  var filtersOptions = _ref3.filtersOptions,
      setAdvancedFilters = _ref3.setAdvancedFilters,
      advancedFilters = _ref3.advancedFilters,
      filtersGroup = _ref3.filtersGroup,
      _ref3$mobile = _ref3.mobile,
      mobile = _ref3$mobile === void 0 ? false : _ref3$mobile;
  var filtersByGroup = {};
  var classes = filterStyles(mobile)();

  if (filtersGroup && filtersGroup.length > 0) {
    filtersGroup.forEach(function (group) {
      filtersByGroup[group.name] = {
        label: group.label,
        filters: filtersOptions.filter(function (filter) {
          return filter.group === group.name;
        })
      };
    });
  }

  filtersByGroup['no-group'] = {
    label: '',
    filters: filtersOptions.filter(function (filter) {
      return !filter.group;
    })
  };
  return Object.keys(filtersByGroup).map(function (key, idx) {
    var group = filtersByGroup[key];

    if (!group.filters || group.filters.length === 0) {
      return null;
    }

    var style = {
      marginLeft: mobile && '10px'
    };
    return [idx > 0 && /*#__PURE__*/React.createElement(Divider, {
      key: "divider-".concat(key)
    }), /*#__PURE__*/React.createElement("div", {
      key: "group-".concat(key),
      className: classes.group
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "subtitle2",
      style: style
    }, group.label), /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.filterContainer
    }, group.filters.map(function (filter) {
      var mobileWidth = mobile ? {
        width: '100%'
      } : {};
      return /*#__PURE__*/React.createElement(Grid, {
        item: true,
        xs: 12,
        className: classes.gridItemMarginTop,
        key: filter.name
      }, /*#__PURE__*/React.createElement("div", {
        key: "filter-".concat(filter.name),
        className: clsx(classes.filter, _defineProperty({}, classes.fullWidth, filter.fullWidth)),
        style: mobileWidth
      }, mapFilterOptionToInput(filter, setAdvancedFilters, advancedFilters)));
    })))];
  });
};

var Container = function Container(_ref4) {
  var advancedFiltersProp = _ref4.advancedFilters,
      onApplyFilter = _ref4.onApplyFilter,
      filters = _ref4.filters,
      closeDialog = _ref4.closeDialog,
      _ref4$mobile = _ref4.mobile,
      mobile = _ref4$mobile === void 0 ? false : _ref4$mobile,
      customAdvancedFilters = _ref4.customAdvancedFilters;

  var _useTheme = useTheme(),
      variant = _useTheme.variant;

  var filtersOptions = advancedFiltersProp.filters,
      filtersGroup = advancedFiltersProp.filtersGroup;

  var _useState = useState(_objectSpread({}, filters.advancedFilters)),
      _useState2 = _slicedToArray(_useState, 2),
      advancedFilters = _useState2[0],
      setAdvancedFilters = _useState2[1];

  var _useContext = useContext(LocaleContext),
      _useContext$Table = _useContext.Table,
      tooltipAdvancedFilter = _useContext$Table.tooltipAdvancedFilter,
      applyFiltersLabel = _useContext$Table.applyFiltersLabel;

  var classes = advancedFilterStyles(mobile)();

  var handleClick = function handleClick() {
    if (customAdvancedFilters) {
      customAdvancedFilters.applyFilters();
      closeDialog();
    } else {
      onApplyFilter(advancedFilters);
    }
  };

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, mobile && /*#__PURE__*/React.createElement(IconButton, {
    onClick: closeDialog
  }, /*#__PURE__*/React.createElement(Icon, {
    path: mdiArrowLeft,
    size: 1
  })), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    alignItems: "center",
    justify: "space-between"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    id: "tableTitle"
  }, tooltipAdvancedFilter), !mobile && /*#__PURE__*/React.createElement(IconButton, {
    onClick: closeDialog
  }, /*#__PURE__*/React.createElement(Icon, {
    path: mdiClose,
    size: 1
  })))), !customAdvancedFilters ? /*#__PURE__*/React.createElement(Filters, {
    filtersOptions: filtersOptions,
    setAdvancedFilters: setAdvancedFilters,
    advancedFilters: advancedFilters,
    filtersGroup: filtersGroup,
    mobile: mobile
  }) : customAdvancedFilters.filters, /*#__PURE__*/React.createElement("div", {
    className: clsx(classes.panelButton, _defineProperty({}, classes.panelButtonMobile, mobile))
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleClick,
    variant: "contained",
    className: classes.button,
    color: renderStyledColor(variant),
    disableElevation: true
  }, applyFiltersLabel), (customAdvancedFilters === null || customAdvancedFilters === void 0 ? void 0 : customAdvancedFilters.cleanFilters) && /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return customAdvancedFilters.cleanFilters();
    },
    variant: "outlined",
    className: classes.button,
    color: renderStyledColor(variant),
    disableElevation: true
  }, (customAdvancedFilters === null || customAdvancedFilters === void 0 ? void 0 : customAdvancedFilters.cleanFiltersLabel) || 'Limpar Filtros')));
};

export default Container;